import { Component } from "react";
import TopNav from "../components/top_nav";
import Footer from "../components/footer";
import { toast } from "react-toastify";
import ContactService from "../services/contact_service";

export default class ContactScreen extends Component {
    state = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        loading: false,
    };

    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    };

    isFormValid = () => {
        const { firstName, lastName, email, phone, message } = this.state;
        return (
            firstName.trim() !== "" &&
            lastName.trim() !== "" &&
            email.trim() !== "" &&
            phone.trim() !== "" &&
            message.trim() !== ""
        );
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { firstName, lastName, email, phone, message } = this.state;

        this.setState({ loading: true });

        const data = { firstName, lastName, email, phone, message };

        try {
            const result = await ContactService.createMessage(data);
            console.log("Response from server:", result);

            // Check your actual backend response structure here
            if (result && result.status === 200) {
                toast.success("Message sent successfully!");
                this.setState({
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    message: "",
                });
            } else {
                toast.error("Failed to send message.");
            }
        } catch (error) {
            toast.error("Something went wrong.");
            console.error("Error:", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { firstName, lastName, email, phone, message, loading } = this.state;

        return (
            <div className="bg-grey-color">
                <TopNav />
                <div className="container py-5">
                    <div className="row rounded-4 p-4 p-md-4">
                        {/* Left Section */}
                        <div className="col-md-6 pe-md-5 mb-4 mb-md-0">
                            <p className="fs-18">Contact us</p>
                            <h2 className="fw-bold mb-4 fs-52">Get in Touch with BHEPL</h2>
                            <p className="text-muted mb-5">
                                We’re here to help your business grow and succeed. Reach out to us for
                                inquiries, consultations, or partnership opportunities. Our team is ready
                                to assist you with tailored solutions that meet your needs.
                            </p>

                            <div className="row">
                                <div className="col-md-6 mb-4">
                                    <h5 className="fs-28">Email</h5>
                                    <p className="mb-1">info@bhepl.com</p>
                                    <p></p>
                                </div>

                                <div className="col-md-6 mb-4">
                                    <h5 className="fs-28">Phone</h5>
                                    <p className="mb-1">+91 9100900144</p>
                                    <p></p>
                                </div>
                            </div>

                            <div>
                                <h5 className="fs-28">Address</h5>
                                <p>
                                    BHARAT HEAVY ENGINEERING PVT LTD,<br />
                                    Plot No 1/C, Sy No 83/1,<br /> Raidurgam panmaktha Hyderabad Knowledge City,<br />
                                    Serilingampally, Hyderabad, Telangana 500081.
                                </p>
                            </div>
                        </div>

                        {/* Right Section - Form */}
                        <div className="col-md-6">
                            <h4 className="fw-semibold mb-4 fs-28">Send Us a Message</h4>
                            <form onSubmit={this.handleSubmit}>
                                <div className="d-flex flex-column flex-md-row gap-3">
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="firstName" className="form-label">First Name</label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            value={firstName}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="First name"
                                        />
                                    </div>
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="lastName" className="form-label">Last Name</label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            value={lastName}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="Last name"
                                        />
                                    </div>
                                </div>

                                <div className="d-flex flex-column flex-md-row gap-3">
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            value={email}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="mb-4 flex-grow-1">
                                        <label htmlFor="phone" className="form-label">Phone Number</label>
                                        <input
                                            type="text"
                                            id="phone"
                                            value={phone}
                                            onChange={this.handleChange}
                                            className="form-control rounded-pill bg-black-05 border-black-20 py-2 px-20px mt-1"
                                            placeholder="Phone Number"
                                        />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="message" className="form-label">Message</label>
                                    <textarea
                                        id="message"
                                        value={message}
                                        onChange={this.handleChange}
                                        className="form-control rounded-4 bg-black-05 border-black-20"
                                        rows="8"
                                        placeholder="Add a cover letter or anything else you want to share"
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    className="btn w-100 py-3 text-white rounded-3 fs-14"
                                    style={{ backgroundColor: "#193E6C" }}
                                    disabled={!this.isFormValid() || loading}
                                >
                                    {loading ? "Sending..." : "Submit request"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}
